// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- EXISTING CSS (Keep your layout, just add these new parts) --- */

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.pay-adjustment-container {
  padding: 4px 15px;
  background-color: #f9f9f9;
  border-radius: 8px;
  margin: 0px 10px 0px 10px;
}

/* --- CONTROLS --- */
.controls-pay-adjustment {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  align-items: center;
  flex-wrap: wrap;
}

.search-input {
  flex-grow: 1;
  max-width: 17vw;
  border: 1px solid #c4c3c3;
  height: 30px;
  border-radius: 6px;
  padding: 8px;
}

.filter-select {
  width: 15vw;
  border: 1px solid #c4c3c3;
  height: 30px;
  border-radius: 6px;
  padding: 0 8px;
  background-color: white;
  cursor: pointer;
}

.table-container__pay_adjustment {
  border: 1px solid rgb(122, 122, 122);
  border-radius: 8px;
  background-color: white;
 max-height: 250px;
  overflow-y: auto; 
  overflow-x: hidden;
  position: relative; 
}

.attendance-table__pay_adjustment {
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
}

.attendance-table__pay_adjustment th {
  color: #333;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 11px; /* Slightly larger for readability */
  padding: 10px;
  border: 1px solid #e0e0e0;
  position: sticky;
  top: 0;
  z-index: 10;
}

.attendance-table__pay_adjustment td {
  border: 1px solid #e0e0e0;
  padding: 4px 10px;
  text-align: center;
  font-size: 12px;
  color: #444;
}

.attendance-table__pay_adjustment tbody tr:hover {
  background-color: #f1f8ff;
}

.attendance-table__pay_adjustment tbody tr:nth-child(even) {
  background-color: #fafafa;
}

.no-data-cell {
  padding: 40px !important;
  color: #888;
  font-style: italic;
  background-color: white;
}

/* --- ACTION BUTTONS --- */
.actions-cell {
  display: flex;
  justify-content: center;
  gap: 5px;
}

.action-button {
  padding: 5px 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 11px;
  color: white;
  transition: opacity 0.2s;
}

.view-button {
  background-color: #17a2b8;
}

.edit-button {
  background-color: #ffc107;
  color: #212529; /* Dark text for yellow button */
}

.action-button:hover {
  opacity: 0.9;
}

/* --- NEW: ADJUSTMENT BADGES (The pills in the table) --- */
.adj-badge {
  display: inline-block;
  background-color: #e3f2fd;
  color: #0d47a1;
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 11px;
  margin: 2px;
  border: 1px solid #bbdefb;
  white-space: nowrap;
}

/* --- POPUP STYLES --- */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
  backdrop-filter: blur(2px);
}

.popup-content.large-popup {
  background: white;
  width: 700px;
  max-width: 95%;
  max-height: 90vh;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.popup-header {
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f8f9fa;
  border-radius: 8px 8px 0 0;
}

.popup-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.close-popup-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #aaa;
  cursor: pointer;
  line-height: 1;
}

.close-popup-btn:hover {
  color: #333;
}

.popup-body-scrollable {
  padding: 20px;
  overflow-y: auto;
  flex: 1 1;
}

/* --- NEW: Manual Input Fields in Popup --- */
.adj-input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  text-align: right; /* Numbers aligned right */
  font-family: "Consolas", monospace; /* Monospace for numbers */
}

.adj-input:focus {
  outline: none;
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* --- UPLOAD SECTION --- */
.upload-section {
  margin-top: 14px;
  padding: 19px;
  border: 2px dashed #ced4da;
  border-radius: 8px;
  text-align: center;
  background-color: #f8f9fa;
}

.upload-section label {
  display: block;
  margin-bottom: 10px;
  font-weight: 600;
  color: #555;
}

/* --- FOOTER --- */
.popup-footer {
  padding: 5px 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: end;
  align-items: center;
  background-color: #fcfcfc;
  border-radius: 0 0 8px 8px;
}

.right-actions {
  display: flex;
  gap: 10px;
}

.secondary-btn {
  background: #fff;
  border: 1px solid #6c757d;
  color: #6c757d;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
}

.secondary-btn:hover {
  background-color: #e9ecef;
}

.primary-btn,
.primary-btn_adjustment {
  padding: 13px 14px;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  background-color: rgb(116, 197, 167);
  gap: 12px;
  height: 33px;
  width: 84px;
  /* margin-top: 20px; */
}

.primary-btn:hover,
.primary-btn_adjustment:hover {
  background-color: rgb(100, 168, 143);
  color: white;
}

.primary-btn:disabled,
.primary-btn_adjustment:disabled {
  /* background-color: #94d3a2; */
  cursor: not-allowed;
}

.cancel-btn {
  background: #6c757d;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.cancel-btn:hover {
  background-color: #5a6268;
}

/* --- INSTRUCTIONS --- */
.instruction-section {
  border-bottom: 1px solid gray;
  padding: 5px 20px;
}
.instruction-section h4 {
  margin-top: 0;
  color: #0056b3;
  font-size: 16px;
}
.instruction-section p {
  font-size: 13px;
  color: #666;
  margin-bottom: 15px;
}
.instruction-section h5 {
  margin: 0px 0 10px;
  color: #333;
  font-size: 14px;
}

.instruction-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  margin-bottom: 15px;
  border: 1px solid #dee2e6;
}

.instruction-table th {
  background-color: #f8f9fa;
  font-weight: 600;
}
.instruction-table th,
.instruction-table td {
  border: 1px solid #dee2e6;
  padding: 8px;
  text-align: left;
}

.note-section {
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  color: #856404;
  padding: 12px;
  border-radius: 6px;
  font-size: 13px;
}
.note-section ul {
  padding-left: 20px;
  margin: 0;
}
.note-section li {
  margin-bottom: 3px;
  text-align: start;
}

.search-wrapper {
  position: relative;
  /* width: 320px; */
}

.suggestion-box {
  position: absolute;
  top: 45px;
  width: 230px;
  background: rgb(242, 239, 239);
  border: 1px solid #ddd;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  z-index: 999;
  max-height: 250px;
  overflow-y: auto;
}

.suggestion-item {
  padding: 10px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
}

.suggestion-item:hover {
  background: #f5f5f5;
}

.emp-name {
  font-size: 14px;
  margin-left: 10px;
  color: #666;
}

.search-input-container {
  /* position: relative; */
  display: flex;
  flex-direction: column;
  /* width: ; */
}

.clear-search {
  position: absolute;
  right: 10px;
  top: 7px;
  cursor: pointer;
  font-size: 14px;
  color: #888;
}

.clear-search:hover {
  color: #d32f2f;
}

.final-save-container {
  position: sticky;
  bottom: 0;

  display: flex;
  justify-content: flex-end;

  padding: 10px;
  /* background: white; */
  /* border-top: 1px solid #eee; */
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/GenerateSalaryComponent/PayRole/PayAdjustment/PayAdjustment.css"],"names":[],"mappings":"AAAA,sEAAsE;;AAEtE;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,4DAA4D;AAC9D;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,uBAAuB;CACxB,iBAAiB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,eAAe,EAAE,oCAAoC;EACrD,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc,EAAE,gCAAgC;AAClD;;AAEA;EACE,YAAY;AACd;;AAEA,4DAA4D;AAC5D;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;AACT;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB,EAAE,0BAA0B;EAC7C,kCAAkC,EAAE,0BAA0B;AAChE;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,SAAS;EACT,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;;EAEE,oCAAoC;EACpC,YAAY;AACd;;AAEA;;EAEE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;EACtB,0CAA0C;EAC1C,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;;EAET,aAAa;EACb,yBAAyB;;EAEzB,aAAa;EACb,uBAAuB;EACvB,gCAAgC;AAClC","sourcesContent":["/* --- EXISTING CSS (Keep your layout, just add these new parts) --- */\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.pay-adjustment-container {\n  padding: 4px 15px;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  margin: 0px 10px 0px 10px;\n}\n\n/* --- CONTROLS --- */\n.controls-pay-adjustment {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 5px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.search-input {\n  flex-grow: 1;\n  max-width: 17vw;\n  border: 1px solid #c4c3c3;\n  height: 30px;\n  border-radius: 6px;\n  padding: 8px;\n}\n\n.filter-select {\n  width: 15vw;\n  border: 1px solid #c4c3c3;\n  height: 30px;\n  border-radius: 6px;\n  padding: 0 8px;\n  background-color: white;\n  cursor: pointer;\n}\n\n.table-container__pay_adjustment {\n  border: 1px solid rgb(122, 122, 122);\n  border-radius: 8px;\n  background-color: white;\n max-height: 250px;\n  overflow-y: auto; \n  overflow-x: hidden;\n  position: relative; \n}\n\n.attendance-table__pay_adjustment {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: #fff;\n}\n\n.attendance-table__pay_adjustment th {\n  color: #333;\n  font-weight: 600;\n  text-transform: uppercase;\n  font-size: 11px; /* Slightly larger for readability */\n  padding: 10px;\n  border: 1px solid #e0e0e0;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.attendance-table__pay_adjustment td {\n  border: 1px solid #e0e0e0;\n  padding: 4px 10px;\n  text-align: center;\n  font-size: 12px;\n  color: #444;\n}\n\n.attendance-table__pay_adjustment tbody tr:hover {\n  background-color: #f1f8ff;\n}\n\n.attendance-table__pay_adjustment tbody tr:nth-child(even) {\n  background-color: #fafafa;\n}\n\n.no-data-cell {\n  padding: 40px !important;\n  color: #888;\n  font-style: italic;\n  background-color: white;\n}\n\n/* --- ACTION BUTTONS --- */\n.actions-cell {\n  display: flex;\n  justify-content: center;\n  gap: 5px;\n}\n\n.action-button {\n  padding: 5px 10px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 11px;\n  color: white;\n  transition: opacity 0.2s;\n}\n\n.view-button {\n  background-color: #17a2b8;\n}\n\n.edit-button {\n  background-color: #ffc107;\n  color: #212529; /* Dark text for yellow button */\n}\n\n.action-button:hover {\n  opacity: 0.9;\n}\n\n/* --- NEW: ADJUSTMENT BADGES (The pills in the table) --- */\n.adj-badge {\n  display: inline-block;\n  background-color: #e3f2fd;\n  color: #0d47a1;\n  padding: 3px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  margin: 2px;\n  border: 1px solid #bbdefb;\n  white-space: nowrap;\n}\n\n/* --- POPUP STYLES --- */\n.popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1050;\n  backdrop-filter: blur(2px);\n}\n\n.popup-content.large-popup {\n  background: white;\n  width: 700px;\n  max-width: 95%;\n  max-height: 90vh;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n  animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateY(-20px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.popup-header {\n  padding: 15px 20px;\n  border-bottom: 1px solid #eee;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #f8f9fa;\n  border-radius: 8px 8px 0 0;\n}\n\n.popup-header h3 {\n  margin: 0;\n  font-size: 18px;\n  color: #333;\n}\n\n.close-popup-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: #aaa;\n  cursor: pointer;\n  line-height: 1;\n}\n\n.close-popup-btn:hover {\n  color: #333;\n}\n\n.popup-body-scrollable {\n  padding: 20px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n/* --- NEW: Manual Input Fields in Popup --- */\n.adj-input {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  text-align: right; /* Numbers aligned right */\n  font-family: \"Consolas\", monospace; /* Monospace for numbers */\n}\n\n.adj-input:focus {\n  outline: none;\n  border-color: #80bdff;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n/* --- UPLOAD SECTION --- */\n.upload-section {\n  margin-top: 14px;\n  padding: 19px;\n  border: 2px dashed #ced4da;\n  border-radius: 8px;\n  text-align: center;\n  background-color: #f8f9fa;\n}\n\n.upload-section label {\n  display: block;\n  margin-bottom: 10px;\n  font-weight: 600;\n  color: #555;\n}\n\n/* --- FOOTER --- */\n.popup-footer {\n  padding: 5px 20px;\n  border-top: 1px solid #eee;\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  background-color: #fcfcfc;\n  border-radius: 0 0 8px 8px;\n}\n\n.right-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.secondary-btn {\n  background: #fff;\n  border: 1px solid #6c757d;\n  color: #6c757d;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.secondary-btn:hover {\n  background-color: #e9ecef;\n}\n\n.primary-btn,\n.primary-btn_adjustment {\n  padding: 13px 14px;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  background-color: rgb(116, 197, 167);\n  gap: 12px;\n  height: 33px;\n  width: 84px;\n  /* margin-top: 20px; */\n}\n\n.primary-btn:hover,\n.primary-btn_adjustment:hover {\n  background-color: rgb(100, 168, 143);\n  color: white;\n}\n\n.primary-btn:disabled,\n.primary-btn_adjustment:disabled {\n  /* background-color: #94d3a2; */\n  cursor: not-allowed;\n}\n\n.cancel-btn {\n  background: #6c757d;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.cancel-btn:hover {\n  background-color: #5a6268;\n}\n\n/* --- INSTRUCTIONS --- */\n.instruction-section {\n  border-bottom: 1px solid gray;\n  padding: 5px 20px;\n}\n.instruction-section h4 {\n  margin-top: 0;\n  color: #0056b3;\n  font-size: 16px;\n}\n.instruction-section p {\n  font-size: 13px;\n  color: #666;\n  margin-bottom: 15px;\n}\n.instruction-section h5 {\n  margin: 0px 0 10px;\n  color: #333;\n  font-size: 14px;\n}\n\n.instruction-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n  margin-bottom: 15px;\n  border: 1px solid #dee2e6;\n}\n\n.instruction-table th {\n  background-color: #f8f9fa;\n  font-weight: 600;\n}\n.instruction-table th,\n.instruction-table td {\n  border: 1px solid #dee2e6;\n  padding: 8px;\n  text-align: left;\n}\n\n.note-section {\n  background-color: #fff3cd;\n  border: 1px solid #ffeeba;\n  color: #856404;\n  padding: 12px;\n  border-radius: 6px;\n  font-size: 13px;\n}\n.note-section ul {\n  padding-left: 20px;\n  margin: 0;\n}\n.note-section li {\n  margin-bottom: 3px;\n  text-align: start;\n}\n\n.search-wrapper {\n  position: relative;\n  /* width: 320px; */\n}\n\n.suggestion-box {\n  position: absolute;\n  top: 45px;\n  width: 230px;\n  background: rgb(242, 239, 239);\n  border: 1px solid #ddd;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);\n  z-index: 999;\n  max-height: 250px;\n  overflow-y: auto;\n}\n\n.suggestion-item {\n  padding: 10px;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n}\n\n.suggestion-item:hover {\n  background: #f5f5f5;\n}\n\n.emp-name {\n  font-size: 14px;\n  margin-left: 10px;\n  color: #666;\n}\n\n.search-input-container {\n  /* position: relative; */\n  display: flex;\n  flex-direction: column;\n  /* width: ; */\n}\n\n.clear-search {\n  position: absolute;\n  right: 10px;\n  top: 7px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #888;\n}\n\n.clear-search:hover {\n  color: #d32f2f;\n}\n\n.final-save-container {\n  position: sticky;\n  bottom: 0;\n\n  display: flex;\n  justify-content: flex-end;\n\n  padding: 10px;\n  /* background: white; */\n  /* border-top: 1px solid #eee; */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
